<template>
  <div class="header-and-footer">
    <header>
      <div style="
          width: 100%;
          display: flex;
          justify-content: center;
          background-color: #fff;
          position: fixed;
          top: 0;
          z-index: 999;
        ">
        <div class="header">
          <div class="header-left">
            <div class="logo" @click="toPath('index', '', 'navLogo')"></div>
            <div class="function-list">
              <div class="function-list-item" :class="{ active: activeName == 'index' }"
                @click="toPath('index', '', 'navLogo')">
                首页
              </div>
              <div class="function-list-item" :class="{ active: activeName == 'server-product' }">
                <span>服务产品</span>
                <div class="hover-container">
                  <div class="hover-container-item" style="margin-top: 0.5rem" @click="watchMore('0')">
                    <div>
                      <span>集卡运输</span>
                    </div>
                  </div>
                  <div class="hover-container-item" @click="watchMore('1')">
                    <div>
                      <span>出口报关</span>
                    </div>
                  </div>
                  <div class="hover-container-item" @click="watchMore('2')">
                    <div>
                      <span>监装检验</span>
                    </div>
                  </div>
                  <div class="hover-container-item" style="margin-bottom: 1.5rem" @click="watchMore('3')">
                    <div>
                      <span>数字协同</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="function-list-item" :class="{ active: activeName == 'order' }">
                <span>订单中心</span>
                <div class="hover-container">
                  <div class="hover-container-item" style="margin-top: 0.5rem" @click="toPath('order-booking')">
                    <div>
                      <span>我的订单</span>
                    </div>
                  </div>
                  <div class="hover-container-item" @click="toPath('container-orders')">
                    <div>
                      <span>箱单查询</span>
                    </div>
                  </div>
                  <div class="hover-container-item" @click="toPath('fee-confirmation')">
                    <div>
                      <span>费用确认</span>
                    </div>
                  </div>
                  <div class="hover-container-item" style="margin-bottom: 0.5rem" @click="toPath('account-checking')">
                    <div>
                      <span>月结对账</span>
                    </div>
                  </div>
                  <div class="hover-container-item" style="margin-bottom: 0.5rem"
                    @click="toPath('cross-border-logistics')">
                    <div>
                      <span>好柜跟踪</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="function-list-item" :class="{ active: activeName == 'service-advisory' }">
                <span>服务支持</span>
                <div class="hover-container small">
                  <div class="hover-container-item" style="margin-top: 0.5rem" @click="consultService">
                    <div>
                      <span>服务咨询</span>
                    </div>
                  </div>
                  <div class="hover-container-item" @click="contactService">
                    <div>
                      <span>联系客服</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="function-list-item" :class="{ active: activeName == 'about' }" @click="toPath('about')">
                关于我们
              </div>
            </div>
          </div>
          <div class="header-right">
            <div class="phone" style="color: #02cad6; font-size: 16px">
              <i class="iconfont icondianhua1"></i>
              <span style="font-weight: 600">021-36622199</span>
            </div>
            <div class="switch-bar">
              <span style="cursor: pointer">中</span>&nbsp;&nbsp;&nbsp;
              <span @click="toEnglish" style="cursor: pointer; color: #d3d3d3">En</span>
            </div>
            <div v-if="!isLogin" class="login-bar">
              <span class="no-login" @click="toPath('login')">登录</span>
            </div>
            <div class="user-name" v-else>
              <div class="login-name">
                <span>{{ user.userDisplayName }}</span>
              </div>
              <div class="user-more">
                <div class="user-more-item" @click="toPath('personal-center')">
                  个人中心
                </div>
                <div class="user-more-item" @click="logout">退出登录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <slot>内容</slot>
    <footer style="background: rgb(30, 55, 64)">
      <div class="footer">
        <!-- <div class="logo"></div> -->
        <div class="aboutUs">
          <div class="first">
            <div>
              <div style="line-height: 38px; font-weight: 600; margin-top: 8px">
                投诉电话（24小时）
              </div>
              <div style="font-size: 40px; font-weight: 900">021-36622199</div>
              <!-- <div>上海市宝山区同济路669号6号楼9、11、15、16楼</div> -->
            </div>
            <div>
              <div class="wechat-wrapper">
                <img src="../images/鸭嘴兽科技二维码.jpg" />鸭嘴兽科技
              </div>
              <div class="wechat-wrapper" style="margin-left: 20px">
                <img src="../images/鸭嘴兽拖卡二维码.jpg" />鸭嘴兽拖卡
              </div>
              <div class="wechat-wrapper" style="margin-left: 20px">
                <img src="../images/website-qrcode.jpg" />客户端小程序
              </div>
            </div>
          </div>
        </div>
        <div class="reference">
          <div>
            2017-{{nowYear}}
            <svg t="1656397769079" style="vertical-align: text-bottom" class="icon" viewBox="0 0 1024 1024"
              version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10742" width="16" height="16">
              <path
                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                p-id="10743" fill="#fff"></path>
              <path
                d="M517.6 351.3c53 0 89 33.8 93 83.4 0.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c0.1-87 37-135.5 102.2-135.5z"
                p-id="10744" fill="#fff"></path>
            </svg>
            <span v-if="hljHost">黑龙江鸭嘴兽供应链管理有限公司 版权所有</span>
            <span v-else-if="tjHost">天津鸭嘴兽现代物流有限公司 版权所有</span>
            <span v-else>宁波鸭嘴兽网络科技有限公司 版权所有</span>
          </div>
          <div>
            <img v-if="!hljHost && !tjHost " style="
                display: inline-block;
                vertical-align: sub;
                margin-right: 10px;
              " src="../images/certIcon.png" />
              <a v-if="duckbillHost" style="color: #fff" target="_blank" rel="noreferrer"
                href="https://beian.mps.gov.cn/#/query/webSearch?code=33020602001564">浙公网安备33020602001564号</a>
              <a v-if="yzsHost" style="color: #fff" target="_blank" rel="noreferrer"
                href="https://beian.mps.gov.cn/#/query/webSearch?code=33020602001565">浙公网安备33020602001565号</a>
              <a v-if="devHost" style="color: #fff" target="_blank" rel="noreferrer"
                href="https://beian.mps.gov.cn/#/query/webSearch?code=33020602001565">浙公网安备33020602001565号</a>
          </div>
            <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff;">
              <div v-if="hljHost">黑ICP备2022009768</div>
              <div v-else-if="tjHost">津ICP备2023000376号</div>
              <div v-else>浙ICP备2025180488号</div>
            </a>
          <!-- <p v-if="duckbillHost" style="height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#ccc;">上海鸭嘴兽供应链管理有限公司持有的增值电信业务经营许可证，证书编号为：沪 B2-20190884，将依法进行许可证注销。</p> -->
        </div>
      </div>
    </footer>
    <newModal ref="newModal" :type="newModalInfo.type" :messageInfo="newModalInfo.messageInfo"
      :isConfirm="newModalInfo.isConfirm" @onOk="newModalInfo.onOk" :okBtnText="newModalInfo.okBtnText" />
    <chatPop v-if="showChatPop" ref="chatpop" page="header"></chatPop>
    <registerModal ref="registerModal" />
    <Modal v-model="loginModal.show" width="350" class="modal-no-bottom">
      <div style="padding: 20px 0; font-size: 22px; text-align: center">
        <div style="margin: 10px 0">
          <Icon type="alert-circled" color="#f90" size="50"></Icon>
        </div>
        <p style="font-size: 16px">
          您还未登录，请<a @click="toPath('register-personal')">注册</a>/<a @click="toPath('login')">登录</a>后再操作
        </p>
      </div>
    </Modal>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import util from "../libs/util";
import ChatPop from "../components/chat-pop.vue";
import registerModal from "@/components/new-register/index.vue";
import { get } from "lodash";
import newModal from "@/components/new-modal";
import { getTruckLock, forCompanyList, getUserCompanyStatus, getUserCompanyInfoByName, applyForCompany } from "@/api/home";
import env from "@/config/config";
import { encrypt } from "@/libs/encrypt-and-decode.js";
import { log } from "video.js";
import { getUserInfo } from '@/api/home'
export default {
  name: "header-and-footer",
  props: {
    footer: {
      type: Boolean,
      default: true,
    },
    hasNav: {
      type: Boolean,
      default: true,
    },
    hasFooter: {
      type: Boolean,
      default: true,
    },
    isBottom: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showChatPop: true,
      duckbillHost: false,
      yzsHost: false,
      devHost: false,
      hljHost:false,
      tjHost:false,
      user: {},
      companyInfo: false,
      companyInfoDetail: {},
      companyStatus: "",
      loginModal: {
        show: false,
      },
      newModalInfo: {
        type: "info",
        isConfirm: false,
        okBtnText: "",
        onOk: () => { },
      },
      nowYear:new Date().getFullYear()
    };
  },
  components: {
    ChatPop,
    registerModal,
    newModal,
  },
  watch: {},
  mounted() {
    this.getCurrentUser();
    this.handleSwitchHost();
  },
  computed: {
    isLogin() {
      return !util.isEmptyObject(this.user);
    },
    activeName() {
      return this.$route.name;
    },
  },
  methods: {
    applyForCompanyHttp() {
      this.getUserCompanyInfoByName()
    },
    getUserCompanyInfoByName() {
      getUserCompanyInfoByName({
        companyName: Cookies.get("companyName"),
      }).then(res => {
        console.log('获取公司信息', res.data)
        if (res && res.data.success) {
          let data = JSON.parse(res.data.data.value)
          if (data && data.data) {
            this.companyInfoDetail = JSON.parse(data.data)
            this.companyInfo = true
            this.applyForCompany()
          } else {
            this.companyInfo = false
          }
        }
      })
    },
    applyForCompany() {
      applyForCompany({
        companyId: this.companyInfoDetail.id
      }).then(res => {
        console.log('用户申请加入公司', res.data)
        if (res && res.data.success) {
          this.newModalInfo = {
            type: 'success',
            messageInfo: `鸭嘴兽已收到您的请求<br>我们会在30分钟内进行审核请注意手机短信`,
            isConfirm: false,
            okBtnText: '关闭',
            onOk: () => {
              this.$refs['newModal'].show(false)
            }
          }
          this.$refs['newModal'].show()
        } else {
          this.$Message.error(res.data.message)
        }
      })
    },
    toEnglish() {
      console.log(env);
      if (env.env == "development") {
        window.location.href = "http://qaen.duckbillscm.com/#/";
      } else {
        window.location.href = "https://en.duckbillscm.com/";
      }
    },
    // 联系客服
    contactService() {
      this.showChatPop = true;
      this.$refs.chatpop.judgeUser();
    },
    // 服务咨询
    consultService() {
      this.$router.push({
        name: "service-advisory",
      });
      // this.showChatPop = true
      // this.$refs.chatpop.consultService()
    },
    baiduTongji(name) {
      _hmt.push([
        "_trackEvent",
        "PC-首页",
        "PC-首页-" + name,
        this.isLogin ? `用户名:${Cookies.get("user")}` : "未登录",
      ]);
    },
    watchMore(params) {
      // 0: 集卡运输  1：出口报关  2：监装检验 3：数字协同
      // document.getElementById("main").scrollTop = 0;
      console.log(params);
      this.toPath("server-product", params);
      // this.$router.push({
      //   name: 'server-product',
      //   query: {
      //     tabsName: params
      //   }
      // })
    },
    getUserCompanyStatus() {
      getUserCompanyStatus()
        .then((res) => {
          console.log("获取用户是否加入公司", res);
          if (res.data.success) {
            let data = JSON.parse(res.data.data.value);
            this.companyStatus = data.status;
          }
        })
        .catch((error) => {
          let msg = get(error, "response.data.message");
          if (msg === "请先登录") {
            // this.loginModal.show = true;
          } else {
            this.$Message.info({
              content:
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                "系统错误",
            });
          }
        });
    },
    // 判断公司是否可以加入
    checkCompany() {
      this.companyStatus = "";
      console.log('Cookies.get("companyName")', Cookies.get("companyName"));
      if (this.$route.query.type == 'f2e') {
        return;
      }
      if (Cookies.get("companyName") == 'undefined') {
        this.getUserCompanyStatus();
        return;
      }
      forCompanyList({
        companyName: Cookies.get("companyName"),
      }).then((res) => {
        this.companyInfo = false;
        if (res.data) {
          this.companyInfo = true;
        }
        this.getUserCompanyStatus();
      });
    },
    // 页面跳转
    toPath(pathName, typeVal, tracking) {
      let tongjiPathConfig = {
        login: "登录",
        register: "注册",
        index: "首页",
        // 'about': '了解详情',
        "query-charge-new": "拖车运价",
        "truck-location": "货车位置",
        // 'courier-query': '快递查询',
      };
      let tongjiTrackingConfig = {
        navArticles: "咨询百科",
        navNews: "公司新闻",
        navInformation: "行业动态",
        navAbout: "关于我们",
        navTransport: "运力介绍",
        navTeams: "专业队伍",
        navHonor: "资质荣誉",
        navPartner: "合作伙伴",
        navService: "服务承诺",
      };
      if (tongjiPathConfig[pathName]) {
        this.baiduTongji(tongjiPathConfig[pathName]);
      } else if (tongjiTrackingConfig[tracking]) {
        this.baiduTongji(tongjiTrackingConfig[tracking]);
      }
      if (pathName == "news-center") {
        this.$Message.info("此功能正在建设中...");
        return;
      }
      if (
        !this.isLogin &&
        (pathName == "home" ||
          pathName == "shipping-bill" ||
          pathName == "order-tracking" ||
          pathName == "place-order" ||
          pathName == "order-booking" ||
          pathName == "container-orders" ||
          pathName == "fee-confirmation" ||
          pathName == "account-checking")
      ) {
        // this.pathName = "home";
        // this.loginFade = true;
        document.getElementById("main").scrollTop = 0;
        this.$router.push({
          path: "login",
          query: {
            pathName: pathName,
          },
        });
        // debugger
      } else {
        if (pathName == "truck-location") {
          console.log("Cookies.get", Cookies.get("truckLock"));
          if (Cookies.get("truckLock") == "false") {
            this.newModalInfo = {
              messageInfo: `受监管要求，本页面货车位置查询功能暂停服务，敬请谅解！`,
              isConfirm: false,
              okBtnText: "确定",
              onOk: () => {
                this.$refs["newModal"].show(false);
              },
            };
            this.$refs["newModal"].show();
            return;
          } else {
            window.sessionStorage.removeItem("plateNumber");
          }
        }
        console.log("companyStatus", this.companyStatus);
        if (
          this.companyStatus != "company" &&
          (pathName == "home" ||
            pathName == "order-booking" ||
            pathName == "fee-confirmation" ||
            pathName == "account-checking" ||
            pathName == "container-orders")
        ) {
          if (this.companyStatus == "no-company") {
            this.newModalInfo = {
              messageInfo: `订单中心需要企业资质<br>您的企业还未认证`,
              isConfirm: false,
              okBtnText: "前往完成认证",
              onOk: () => {
                this.$refs["newModal"].show(false);
                this.$refs["registerModal"].show();
              },
            };
            this.$refs["newModal"].show();
            return;
          } else if (this.companyStatus == "exist-company") {
            // this.newModalInfo = {
            //   messageInfo: `订单中心需要企业资质<br>您的企业已在鸭嘴兽完成审核，是否加入？`,
            //   isConfirm: false,
            //   okBtnText: "立即加入",
            //   onOk: () => {
            //     this.applyForCompanyHttp()
            //   },
            // };
            // this.$refs["newModal"].show();
            // return;
            this.newModalInfo = {
              messageInfo: `订单中心需要企业资质<br>请先加入企业`,
              isConfirm: false,
              okBtnText: "前往加入",
              onOk: () => {
                this.$refs["newModal"].show(false);
                this.$refs["registerModal"].show();
              },
            };
            this.$refs["newModal"].show();
            return;
          } else if (this.companyStatus == "confirm-wait") {
            this.newModalInfo = {
              messageInfo: `订单中心需要企业资质<br>您的企业正在审核中`,
              isConfirm: false,
              okBtnText: "关闭",
              onOk: () => {
                this.$refs["newModal"].show(false);
              },
            };
            this.$refs["newModal"].show();
            return;
          } else if (this.companyStatus == "join-wait") {
            this.newModalInfo = {
              messageInfo: `订单中心需要企业资质<br>加入企业正在审核中`,
              isConfirm: false,
              okBtnText: "关闭",
              onOk: () => {
                this.$refs["newModal"].show(false);
              },
            };
            this.$refs["newModal"].show();
            return;
          } else if (this.companyStatus == "user") {
            this.newModalInfo = {
              messageInfo: `订单中心需要企业资质<br>请先加入企业`,
              isConfirm: false,
              okBtnText: "前往加入",
              onOk: () => {
                this.$refs["newModal"].show(false);
                this.$refs["registerModal"].show();
              },
            };
            this.$refs["newModal"].show();
            return;
          } else {
            // this.toPath("shipping-bill");
          }
          // this.$refs["registerModal"].show();
          // return
        }
        if (pathName == "server-product") {
          this.$router.push({
            name: "server-product",
            query: {
              tabsName: typeVal,
            },
          });
          return;
        }
        if (typeVal) {
          document.getElementById("main").scrollTop = 0;
          this.$router.push({
            path: pathName,
            query: { type: typeVal },
          });
        } else {
          document.getElementById("main").scrollTop = 0;
          this.$router.push({
            path: pathName,
          });
        }
      }
    },
    // 获取当前用户信息
    getCurrentUser(callback) {
      util.ajax_get(this, "/harbour-server/user/current", Date.now(), (response) => {
        if (response.data.success) {
          this.user = response.data.user;
          Cookies.set("user", encrypt(this.user.userName));
          Cookies.set("userId", this.user.id);
          Cookies.set("access", response.data.user.clientUserGroup);
          Cookies.set("isVest", this.user.isVest);
          if (response.data.user.isVest) {
            Cookies.set("authorities", xinjiyuanMenuList.join(","));
          } else {
            Cookies.set(
              "authorities",
              response.data.user.authorities.join(",")
            );
          }
          Cookies.set("accountPeriod", response.data.user.accountPeriod);
          if (callback) callback();
          // this.getUserName(this.user.userName);
          this.getUserName();
          this.getgetTruckLockInfo();
          this.checkCompany();
        } else {
          Cookies.remove("user");
          Cookies.remove('userId')
          this.user = {};
          if (this.activeName == "home_index") {
            this.toPath("index");
          }
          if (callback) callback();
        }
      });
    },
    // getUserName(id) {
    //   util.ajax_get(
    //     this,
    //     "/harbour-server/duckBill/user/getUserNameById",
    //     { userId: id },
    //     (response) => {
    //       console.log("获取用户名", response.data);
    //       this.$set(
    //         this.user,
    //         "getSqlName",
    //         JSON.parse(response.data.data.value).userName
    //       );
    //     }
    //   );
    // },
    async getUserName() {
      const res = await getUserInfo({
        _: Date.now()
      })
      const { userName } = JSON.parse(res.data.data.value)
      console.log(userName, '获取用户名')
      this.$set(
        this.user,
        "getSqlName",
        userName
      );
    },
    getgetTruckLockInfo() {
      getTruckLock().then((res) => {
        if (res && res.data.success) {
          let flag = JSON.parse(res.data.data.value).data;
          Cookies.set("truckLock", flag);
        }
      });
    },
    // 登出
    logout() {
      util.ajax_get(this, "/harbour-server/user/logout", {}, (response) => {
        window.localStorage.removeItem('Bearer')
        if (response.data.success) {
          this.getCurrentUser(() => {
            window.location.reload();
          });
        }
      });
    },
    handleSwitchHost() {
      if (location.href.indexOf("yazuishou.com") > 0) {
        this.yzsHost = true;
      } else {
        this.yzsHost = false;
      }
      if (location.href.indexOf("duckbillscm.com") > 0) {
        this.duckbillHost = true;
      } else {
        this.duckbillHost = false;
      }
      if (location.href.indexOf("driverglobe.com") > 0) {
        this.devHost = true;
      } else {
        this.devHost = false;
      }
      if(location.href.indexOf("yazuishou-hlj.com")>0){
        this.hljHost=true
      }else{
        this.hljHost=false
      }
      if(location.href.indexOf("yazuishou-tj.com")>0){
        this.tjHost=true
      }else{
        this.tjHost=false
      }
    },
  },
  watch: {
    activeName(to) {
      if (to.name === "index") {
        this.activeName = "index";
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "../styles/variable.less";

// 头部样式
.header-and-footer {
  .header {
    min-width: 1300px;
    /*给最小的固定值，*/
    display: flex;
    justify-content: space-between;
    // top: 0;
    // z-index: 10000;
    width: 100%;
    // height: 6.2rem;
    background-color: #fff;
    color: #000;
    max-width: 120rem;
    margin: 0 auto;
    padding: 0 170px;

    .header-left {
      flex: 1;
      display: flex;

      .logo {
        float: left;
        width: 30%;
        margin-right: 3%;
        // margin-right: 5vw;
        // width: 12.35rem;
        // height: 6.39rem;
        background: url("../images/yazuishou_logo.png") no-repeat;
        background-position: center;
        background-size: 85%;
        cursor: pointer;
        vertical-align: middle;
      }

      .function-list {
        float: left;
        display: flex;
        flex: 1;

        .function-list-item {
          // flex: 1;
          cursor: pointer;
          // padding: 0 6px;
          // margin: 0 30px;
          text-align: center;
          min-width: 66px;
          position: relative;

          .hover-container {
            background-color: #fff;
            position: absolute;
            overflow: hidden;
            transition: height 0.5s;
            width: 200%;
            box-shadow: 9px 11px 16px 0px rgba(129, 159, 161, 0.1);

            .hover-container-item {
              background-color: #fff;
              width: 100%;
              text-align: center;
              font-weight: initial;
            }

            .hover-container-item {
              position: relative;

              div:after {
                content: "";
                position: absolute;
                width: 10px;
                display: none;
                height: 18px;
                border-left: 2px solid #02cad6;
                /* bottom: 168px; */
                left: 30%;
                top: 33%;
                width: 9%;
              }
            }

            .hover-container-item:hover {
              div {
                color: @main-color;
              }

              div:after {
                display: block;
              }
            }
          }
        }

        .function-list-item:after {
          content: "";
          position: absolute;
          display: none;
          width: 10px;
          height: 3px;
          border-left: 140px solid @main-color;
          bottom: 0;
          left: 50%;
          width: 70%;
          transform: translateX(-50%);
        }

        .active {
          font-weight: 900;
        }

        .active:after {
          display: inline-block;
        }
      }
    }

    .header-right {
      width: 37%;
      // margin-right: 9vw;
      display: flex;
      justify-content: end;

      .switch-bar {
        min-width: 53px;
        margin-right: 20px;
      }

      .login-bar {
        cursor: pointer;
        margin: 0 20px;
        min-width: 94px;

        .no-login {
          padding: 3px 30px;
          background-color: @main-color;
          color: #fff;
          border: 1px solid @main-color;
        }
      }

      .user-name {
        min-width: 93px;
        cursor: pointer;
        position: relative;

        .login-name {
          text-align: center;
          margin-top: 12px;
          padding: 3px 18px;
          background-color: #fff;
          color: #000;
          // border: 1px solid @main-color;
        }

        .user-more {
          width: 150%;
          line-height: 20px;
          position: absolute;
          margin-top: 10px;
          left: -25%;
          transition: height 0.5s;
          background-color: #fff;
          height: 0rem;
          overflow: hidden;
          text-align: center;
          box-shadow: 9px 11px 16px 0px rgba(129, 159, 161, 0.1);
          z-index: 10000;

          .user-more-item {
            border-top: 1px solid #fff;
            width: 100%;
            line-height: 27px;
            color: #000;
            background-color: #fff;
            font-size: 14px;
          }

          .user-more-item:hover {
            color: @main-color;
          }
        }
      }

      .user-name:hover {
        .user-more {
          height: 4.6rem;
        }
      }
    }
  }

  @media all and (min-width: 1607px) {
    .header {
      height: 5rem;
      padding: 0 170px;

      .header-left {
        .logo {
          width: 9.35rem;
          height: 5rem;
        }

        .function-list {
          flex: 1;

          .function-list-item {
            flex: 1;
            line-height: 5rem;
            font-size: 1.3rem;

            .hover-container {
              width: 150%;
              line-height: 3rem;
              font-size: 1rem;
              top: 5rem;
              left: -25%;
              height: 0rem;
            }
          }

          .function-list-item:hover {
            .hover-container {
              height: 13rem;
            }

            .small {
              height: 6.7rem;
            }
          }
        }
      }

      .header-right {
        .phone {
          margin-right: 33px;
          font-size: 1rem;
          line-height: 80px;
        }

        .switch-bar {
          line-height: 5rem;
          font-size: 1rem;
        }

        .login-bar {
          line-height: 5rem;
          font-size: 1rem;

          .no-login {
            font-size: 1rem;
            line-height: 5rem;
          }
        }

        .user-name {
          .login-name {
            margin-top: 23px;
            font-size: 1rem;
            line-height: 1.5rem;
          }

          .user-more {
            .user-more-item {
              font-size: 1rem;
              line-height: 2rem;
            }
          }
        }
      }
    }
  }

  @media all and (max-width: 1606px) {
    .header {
      height: 5rem;
      padding: 0 100px;

      .header-left {
        .logo {
          width: 9.35rem;
          height: 5rem;
        }

        .function-list {
          .function-list-item {
            flex: 1;
            line-height: 5rem;
            font-size: 1rem;
            min-width: 66px;

            .hover-container {
              width: 150%;
              line-height: 3rem;
              font-size: 1rem;
              top: 5rem;
              left: -25%;
              height: 0rem;
            }
          }

          .function-list-item:hover {
            .hover-container {
              height: 13rem;
            }

            .small {
              height: 6.7rem;
            }
          }
        }
      }

      .header-right {
        .phone {
          margin-right: 33px;
          font-size: 1rem;
          line-height: 5rem;
          min-width: 120px;
        }

        .switch-bar {
          line-height: 5rem;
          font-size: 1rem;
        }

        .login-bar {
          line-height: 5rem;
          font-size: 1rem;

          .no-login {
            font-size: 1rem;
            line-height: 5rem;
          }
        }

        .user-name {
          .login-name {
            margin-top: 23px;
            font-size: 1rem;
            line-height: 1.5rem;
          }

          .user-more {
            .user-more-item {
              font-size: 1rem;
              line-height: 2rem;
            }
          }
        }
      }
    }
  }

  .footer {
    background: url("../images/di.png") no-repeat;
    background-size: cover;
    overflow: hidden;
    position: relative;
    max-width: 120rem;
    min-height: 278px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;

    .aboutUs {
      width: 70vw;
      // display: flex;
      // justify-content: space-around;
      color: #fff;

      // position: absolute;
      // left: 400px;
      // top: 100px;
      .first {
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        font-family: Microsoft YaHei;
        color: #ffffff;
        line-height: 46px;

        .title {
          font-weight: 600;
        }

        .goto {
          cursor: pointer;
        }

        .goto:hover {
          font-weight: 600;
        }

        .wechat-wrapper {
          display: inline-block;
          margin-top: 17px;
          text-align: center;
          font-size: 14px;
          line-height: 32px;

          img {
            width: 100px;
            height: 100px;
            // border-radius: 4px;
          }
        }
      }
    }

    .reference {
      display: flex;
      justify-content: space-between;
      width: 70vw;
      margin: 0 auto;
      position: absolute;
      bottom: 10px;
      left: 0;
      right: 0;
      text-align: center;
      font-size: 14px;
      color: #fff;
      padding: 10px 0px;
      line-height: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// header-and-footer.vue?366de379